/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SurfaceContentBlock } from './SurfaceContentBlock';
import {
    SurfaceContentBlockFromJSON,
    SurfaceContentBlockFromJSONTyped,
    SurfaceContentBlockToJSON,
    SurfaceContentBlockToJSONTyped,
} from './SurfaceContentBlock';

/**
 * 
 * @export
 * @interface SurfaceColumnsConfig
 */
export interface SurfaceColumnsConfig {
    /**
     * 
     * @type {number}
     * @memberof SurfaceColumnsConfig
     */
    columnCount?: SurfaceColumnsConfigColumnCountEnum;
    /**
     * 
     * @type {string}
     * @memberof SurfaceColumnsConfig
     */
    columnSplit?: SurfaceColumnsConfigColumnSplitEnum;
    /**
     * 
     * @type {boolean}
     * @memberof SurfaceColumnsConfig
     */
    stackOnMobile?: boolean;
    /**
     * 
     * @type {Array<Array<SurfaceContentBlock>>}
     * @memberof SurfaceColumnsConfig
     */
    columns?: Array<Array<SurfaceContentBlock>>;
}


/**
 * @export
 */
export const SurfaceColumnsConfigColumnCountEnum = {
    NUMBER_2: 2,
    NUMBER_3: 3
} as const;
export type SurfaceColumnsConfigColumnCountEnum = typeof SurfaceColumnsConfigColumnCountEnum[keyof typeof SurfaceColumnsConfigColumnCountEnum];

/**
 * @export
 */
export const SurfaceColumnsConfigColumnSplitEnum = {
    _5050: '50-50',
    _6040: '60-40',
    _7030: '70-30',
    _4060: '40-60',
    _3070: '30-70',
    _333333: '33-33-33'
} as const;
export type SurfaceColumnsConfigColumnSplitEnum = typeof SurfaceColumnsConfigColumnSplitEnum[keyof typeof SurfaceColumnsConfigColumnSplitEnum];


/**
 * Check if a given object implements the SurfaceColumnsConfig interface.
 */
export function instanceOfSurfaceColumnsConfig(value: object): value is SurfaceColumnsConfig {
    return true;
}

export function SurfaceColumnsConfigFromJSON(json: any): SurfaceColumnsConfig {
    return SurfaceColumnsConfigFromJSONTyped(json, false);
}

export function SurfaceColumnsConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceColumnsConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'columnCount': json['columnCount'] == null ? undefined : json['columnCount'],
        'columnSplit': json['columnSplit'] == null ? undefined : json['columnSplit'],
        'stackOnMobile': json['stackOnMobile'] == null ? undefined : json['stackOnMobile'],
        'columns': json['columns'] == null ? undefined : json['columns'],
    };
}

export function SurfaceColumnsConfigToJSON(json: any): SurfaceColumnsConfig {
    return SurfaceColumnsConfigToJSONTyped(json, false);
}

export function SurfaceColumnsConfigToJSONTyped(value?: SurfaceColumnsConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'columnCount': value['columnCount'],
        'columnSplit': value['columnSplit'],
        'stackOnMobile': value['stackOnMobile'],
        'columns': value['columns'],
    };
}

